import React, { useEffect, useState } from 'react';
import '../styles/Coaching.css';
import { VAN_FEE_OPTIONS } from '../config/fees';

const Coaching = () => {
  const [students, setStudents] = useState([]);
  const [formPayment, setFormPayment] = useState({
    student_id: '',
    amount: '',
    van_fee_amount: '',
    payment_mode: '',
    transaction_id: ''
  });
  const [formStudent, setFormStudent] = useState({
    fullName: '',
    dob: '',
    age: '',
    gender: '',
    phoneNumber: '',
    address: '',
    busRoute: '',
    category: '',
    className: '',
    fatherName: '',
    fatherProfession: '',
    motherName: '',
    motherProfession: '',
    guardianName: '',
    medicalConditions: '',
    aadharCardId: ''
  });
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedCoachingStudent, setSelectedCoachingStudent] = useState(null);
  const [transactionHistory, setTransactionHistory] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormStudent(prev => {
      const updated = { ...prev, [name]: value };

      // Auto-calculate age from dob
      if (name === 'dob') {
        const birthDate = new Date(value);
        const today = new Date();
        const age = today.getFullYear() - birthDate.getFullYear();
        updated.age = today < new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate()) ? age - 1 : age;
      }

      return updated;
    });
  };

  const fetchStudents = async () => {
    const res = await fetch('/backend/api/get_coaching_students.php', {
      credentials: 'include'
    });
    const data = await res.json();
    setStudents(data);
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();

    const res = await fetch('/backend/api/register_coaching_student.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formStudent),
      credentials: 'include'
    });

    const result = await res.json();
    alert(result.message);

    setFormStudent({
      fullName: '',
      dob: '',
      age: '',
      gender: '',
      phoneNumber: '',
      address: '',
      busRoute: '',
      category: '',
      className: '',
      fatherName: '',
      fatherProfession: '',
      motherName: '',
      motherProfession: '',
      guardianName: '',
      medicalConditions: '',
      aadharCardId: ''
    });

    fetchStudents();
  };

  // Fetch transaction history for a student
  const fetchTransactionHistory = async (studentId) => {
    if (!studentId) {
      setTransactionHistory([]);
      return;
    }
    try {
      const res = await fetch(`/backend/api/get_coaching_payment_history.php?student_id=${studentId}`, {
        credentials: 'include'
      });
      const data = await res.json();
      setTransactionHistory(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching transaction history:", err);
      setTransactionHistory([]);
    }
  };

  // --- Print Tuition Bill Logic ---
   // --- Print Combined Bill (Tuition + Van Fee) ---
  const printCoachingBill = ({ student, paymentData }) => {
    const paymentDate = paymentData.date || paymentData.paid_on || new Date().toISOString().split('T')[0];
    const transactionDate = paymentDate.split(' ')[0]; // Get date part if datetime
    const tuitionAmount = Number(paymentData.amount) || 0;
    const vanAmount = Number(paymentData.van_fee_amount) || 0;
    const billNumber = paymentData.bill_number || paymentData.transaction_id || Math.floor(Math.random() * 900000 + 100000);

    const content = `
      <style>
        body { font-family: Arial; font-size: 12px; margin: 0; }
        .page { display: flex; justify-content: space-between; padding: 15mm; box-sizing: border-box; }
        .bill { width: 48%; border: 1px solid #000; padding: 15px; box-sizing: border-box; }
        .bill-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
        .bill-header img { width: 50px; height: 50px; object-fit: contain; }
        .bill-title { flex: 1; text-align: center; font-size: 14px; font-weight: bold; line-height: 1.4; }
        .bill-sub-header { text-align: center; font-size: 11px; margin-bottom: 12px; }
        .row { display: flex; justify-content: space-between; margin-bottom: 5px; }
        .table { width: 100%; margin-top: 10px; border-collapse: collapse; }
        .table th, .table td { border: 1px solid #000; padding: 6px 8px; text-align: left; }
        .sign { text-align: right; margin-top: 25px; font-size: 11px; }
      </style>
      <div class="page">
        ${[1, 2].map(() => `
          <div class="bill">
            <div class="bill-header">
              <img src="${window.location.origin}/school-logo.jpeg" alt="Logo" />
              <div class="bill-title">SHREE MAHARAJA ENGLISH<br>MEDIUM PUBLIC SCHOOL KAMANAKERI</div>
            </div>
            <div class="bill-sub-header">
              KAMANAKERI - 585 314 - Tq. Aland Dist. Kalaburagi<br>
              <strong>COACHING FEE RECEIPT</strong><br>
              <div><strong>FEE Bill No: ${billNumber}</strong></div>
            </div>
            <div class="row"><div>Name: ${student.full_name || student.fullName}</div><div>Date: ${transactionDate}</div></div>
            <div class="row"><div>Class: ${student.class_name || student.className}</div></div>
            <table class="table">
              <tr><th>Particulars</th><th>Amount</th></tr>
              <tr><td>Tuition Fee Paid</td><td>₹${tuitionAmount}</td></tr>
              <tr><td>Van Fee Paid</td><td>₹${vanAmount}</td></tr>
              <tr>
                <td><strong>Total Paid</strong></td>
                <td><strong>₹${tuitionAmount + vanAmount}</strong></td>
              </tr>
            </table>
            <div class="sign">Sign of Cashier/H.M</div>
          </div>
        `).join('')}
      </div>
    `;

    const win = window.open('', '', 'height=800,width=1200');
    win.document.write('<html><head><title>Coaching Fee Bill</title></head><body>');
    win.document.write(content);
    win.document.write('</body></html>');
    win.document.close();

    win.onload = () => {
      const images = win.document.images;
      let loadedCount = 0;

      if (images.length === 0) {
        win.print();
        return;
      }

      for (let img of images) {
        img.onload = img.onerror = () => {
          loadedCount++;
          if (loadedCount === images.length) {
            win.print();
          }
        };
      }
    };
  };

  const handleFeePayment = async (e) => {
    e.preventDefault();

    const payload = {
      ...formPayment,
      amount: parseFloat(formPayment.amount) || 0,
      van_fee_amount: parseFloat(formPayment.van_fee_amount) || 0,
    };

    const res = await fetch('/backend/api/pay_coaching_fee.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'include'
    });

    const result = await res.json();

    if (result.success) {
      alert(result.message);
      setFormPayment({ student_id: '', amount: '', van_fee_amount: '', payment_mode: '', transaction_id: '' });

      if (payload.student_id) {
        const studentRes = await fetch(`/backend/api/get_coaching_student_details.php?id=${payload.student_id}`, {
          credentials: 'include'
        });
        const updatedStudent = await studentRes.json();
        setSelectedCoachingStudent(updatedStudent);

        // Refresh transaction history
        fetchTransactionHistory(payload.student_id);

        // Print the combined bill (even if only one of the fees is paid)
        if ((payload.amount && Number(payload.amount) > 0) || (payload.van_fee_amount && Number(payload.van_fee_amount) > 0)) {
          printCoachingBill({
            student: updatedStudent,
            paymentData: {
              ...payload,
              bill_number: result.bill_number || payload.transaction_id || Math.floor(Math.random() * 900000 + 100000)
            }
          });
        }
      }
      fetchStudents();
    } else {
      alert(result.message || "Payment failed. Please try again.");
    }
  };


  return (
    <div className="coachx-wrapper">
      <h2 className="coachx-heading">🎯 Coaching Management</h2>

      <div className="coachx-sections">
        <div className="coachx-card">
          <h3>Register Student</h3>
          <form onSubmit={handleRegister} className="coachx-form">
            {/* ...[registration form fields, unchanged]... */}
            {/* [Registration code unchanged for brevity, same as in your code above] */}
            <div className="ans-form-group">
              <label htmlFor="fullName">Full Name</label>
              <input
                type="text"
                name="fullName"
                id="fullName"
                value={formStudent.fullName}
                onChange={handleChange}
                required
                pattern=".*\S.*"
                title="Full Name cannot be empty or only spaces"
              />
            </div>
            <div className="ans-form-group">
              <label htmlFor="dob">Date of Birth</label>
              <input type="date" name="dob" id="dob" value={formStudent.dob} onChange={handleChange} required />
            </div>
            <div className="ans-form-group">
              <label htmlFor="age">Age</label>
              <input type="number" name="age" id="age" value={formStudent.age} readOnly />
            </div>
            <div className="ans-form-group">
              <label htmlFor="gender">Gender</label>
              <select name="gender" id="gender" value={formStudent.gender} onChange={handleChange} required>
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="ans-form-group">
              <label htmlFor="phoneNumber">Phone Number</label>
              <input
                type="text"
                name="phoneNumber"
                id="phoneNumber"
                value={formStudent.phoneNumber}
                onChange={handleChange}
                minLength="10"
                maxLength="10"
                pattern="\d{10}"
                title="Phone number must be exactly 10 digits"
                required
              />
            </div>
            <div className="ans-form-group">
              <label htmlFor="address">Address</label>
              <textarea
                name="address"
                id="address"
                value={formStudent.address}
                onChange={handleChange}
                required
                pattern=".*\S.*"
                title="Address cannot be empty or only spaces"
              />
            </div>
            <div className="ans-form-group">
              <label htmlFor="busRoute">Bus Route</label>
              <select name="busRoute" id="busRoute" value={formStudent.busRoute} onChange={handleChange} required>
                <option value="">Select Bus Route</option>
                {VAN_FEE_OPTIONS.map((route) => (
                  <option key={route.value} value={route.value}>{route.label}</option>
                ))}
              </select>
            </div>
            <div className="ans-form-group">
              <label htmlFor="category">Category</label>
              <select name="category" id="category" value={formStudent.category} onChange={handleChange} required>
                <option value="">Select Category</option>
                <option value="General">General</option>
                <option value="OBC">OBC</option>
                <option value="SC">SC</option>
                <option value="ST">ST</option>
                <option value="Others">Others</option>
              </select>
            </div>
            <div className="ans-form-group">
              <label htmlFor="className">Class</label>
              <select name="className" id="className" value={formStudent.className} onChange={handleChange} required>
                <option value="">Select Class</option>
                {[...Array(11).keys()].slice(1).map(num => (
                  <option key={num} value={num}>{num}</option>
                ))}
                <option value="Nursery">Nursery</option>
                <option value="LKG">LKG</option>
                <option value="UKG">UKG</option>
              </select>
            </div>
            <div className="ans-form-group">
              <label htmlFor="fatherName">Father's Name</label>
              <input
                type="text"
                name="fatherName"
                id="fatherName"
                value={formStudent.fatherName}
                onChange={handleChange}
                required
                pattern=".*\S.*"
                title="Father's Name cannot be empty or only spaces"
              />
            </div>
            <div className="ans-form-group">
              <label htmlFor="fatherProfession">Father's Profession</label>
              <input
                type="text"
                name="fatherProfession"
                id="fatherProfession"
                value={formStudent.fatherProfession}
                onChange={handleChange}
                required
                pattern=".*\S.*"
                title="Father's Profession cannot be empty or only spaces"
              />
            </div>
            <div className="ans-form-group">
              <label htmlFor="motherName">Mother's Name</label>
              <input
                type="text"
                name="motherName"
                id="motherName"
                value={formStudent.motherName}
                onChange={handleChange}
                required
                pattern=".*\S.*"
                title="Mother's Name cannot be empty or only spaces"
              />
            </div>
            <div className="ans-form-group">
              <label htmlFor="motherProfession">Mother's Profession</label>
              <input
                type="text"
                name="motherProfession"
                id="motherProfession"
                value={formStudent.motherProfession}
                onChange={handleChange}
                required
                pattern=".*\S.*"
                title="Mother's Profession cannot be empty or only spaces"
              />
            </div>
            <div className="ans-form-group">
              <label htmlFor="guardianName">Guardian's Name</label>
              <input
                type="text"
                name="guardianName"
                id="guardianName"
                value={formStudent.guardianName}
                onChange={handleChange}
              />
            </div>
            <div className="ans-form-group">
              <label htmlFor="medicalConditions">Medical Conditions</label>
              <textarea
                name="medicalConditions"
                id="medicalConditions"
                value={formStudent.medicalConditions}
                onChange={handleChange}
              />
            </div>
            <div className="ans-form-group">
              <label htmlFor="aadharCardId">Aadhar Card ID</label>
              <input
                type="text"
                name="aadharCardId"
                id="aadharCardId"
                value={formStudent.aadharCardId}
                onChange={handleChange}
                minLength="12"
                maxLength="12"
                pattern="\d{12}"
                title="Aadhar Card must be exactly 12 digits"
                required
              />
            </div>
            <button type="submit" className="ans-submit-button">Add Student</button>
          </form>
        </div>

        <div className="coachx-card">
          <h3>Pay Coaching Fee</h3>
          <form onSubmit={handleFeePayment} className="coachx-form">
            <label>
              Class
              <select
                value={selectedClass}
                onChange={async (e) => {
                  const cls = e.target.value;
                  setSelectedClass(cls);

                  if (cls) {
                    const res = await fetch(`/backend/api/get_coaching_students_by_class.php?class_name=${cls}`, {
                      credentials: 'include'
                    });
                    const data = await res.json();
                    setStudents(data);
                  } else {
                    setStudents([]);
                  }

                  setFormPayment({ ...formPayment, student_id: '' });
                  setSelectedCoachingStudent(null);
                }}
                required
              >
                <option value="">-- Select Class --</option>
                <option value="Nursery">Nursery</option>
                <option value="LKG">LKG</option>
                <option value="UKG">UKG</option>
                {[...Array(10).keys()].map(n => (
                  <option key={n + 1} value={n + 1}>{n + 1}</option>
                ))}
              </select>
            </label>

            <label>
              Student
              <select
                value={formPayment.student_id}
                onChange={async (e) => {
                  const studentId = e.target.value;
                  setFormPayment({ ...formPayment, student_id: studentId });

                  if (studentId) {
                    const res = await fetch(`/backend/api/get_coaching_student_details.php?id=${studentId}`, {
                      credentials: 'include'
                    });
                    const data = await res.json();
                    setSelectedCoachingStudent(data);
                    fetchTransactionHistory(studentId);
                  } else {
                    setSelectedCoachingStudent(null);
                    setTransactionHistory([]);
                  }
                }}
                required
              >
                <option value="">-- Select Student --</option>
                {students.map(s => (
                  <option key={s.id} value={s.id}>{s.name} ({s.class_name})</option>
                ))}
              </select>
            </label>

            {selectedCoachingStudent && (
              <div className="coachx-student-details">
                <p><strong>Name:</strong> {selectedCoachingStudent.full_name}</p>
                <p><strong>Class:</strong> {selectedCoachingStudent.class_name}</p>
                <p><strong>Tuition Fee:</strong> ₹{selectedCoachingStudent.tuition_fee}</p>
                <p><strong>Van Fee:</strong> ₹{selectedCoachingStudent.van_fee}</p>
                <p><strong>Total Paid:</strong> ₹{selectedCoachingStudent.total_paid}</p>
                <p><strong>Pending Tuition Fee:</strong> ₹{selectedCoachingStudent.pending_tuition_fee}</p>
                <p><strong>Pending Van Fee:</strong> ₹{selectedCoachingStudent.pending_van_fee}</p>
              </div>
            )}

            <label>
              Amount (Tuition)
              <input
                type="number"
                value={formPayment.amount}
                onChange={(e) => setFormPayment({ ...formPayment, amount: e.target.value })}
                min="0"
                max={selectedCoachingStudent?.pending_tuition_fee || ''}
                required
              />
            </label>

            <label>
              Amount (Van Fee)
              <input
                type="number"
                value={formPayment.van_fee_amount}
                onChange={(e) => setFormPayment({ ...formPayment, van_fee_amount: e.target.value })}
                min="0"
                max={selectedCoachingStudent?.pending_van_fee || ''}
              />
            </label>

            <label>
              Payment Mode
              <select
                value={formPayment.payment_mode}
                onChange={(e) => setFormPayment({ ...formPayment, payment_mode: e.target.value })}
                required
              >
                <option value="">-- Select Mode --</option>
                <option value="UPI">UPI</option>
                <option value="CASH">CASH</option>
                <option value="Concession">Concession</option>
              </select>
            </label>

            <label>
              Transaction ID
              <input
                type="text"
                value={formPayment.transaction_id}
                onChange={(e) => setFormPayment({ ...formPayment, transaction_id: e.target.value })}
                pattern="\S+"
                title="Transaction ID cannot be empty or just spaces"
                required
              />
            </label>

            <button
              type="submit"
              disabled={
                !formPayment.student_id ||
                (!formPayment.amount && !formPayment.van_fee_amount) ||
                !formPayment.payment_mode ||
                !formPayment.transaction_id
              }
            >
              Submit Payment
            </button>
          </form>

          {/* Transaction History Section */}
          {selectedCoachingStudent && transactionHistory.length > 0 && (
            <div style={{ marginTop: '30px', padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
              <h3 style={{ marginBottom: '15px', color: '#333' }}>Transaction History</h3>
              <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f0f0f0', borderBottom: '2px solid #ddd' }}>
                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Sl No</th>
                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Date</th>
                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Tuition Fee</th>
                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Van Fee</th>
                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Total</th>
                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Payment Mode</th>
                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Transaction ID</th>
                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {transactionHistory.map((transaction, index) => {
                    const formatDate = (dateStr) => {
                      if (!dateStr) return '';
                      const date = new Date(dateStr);
                      if (isNaN(date.getTime())) return dateStr;
                      const day = String(date.getDate()).padStart(2, '0');
                      const month = String(date.getMonth() + 1).padStart(2, '0');
                      const year = date.getFullYear();
                      return `${day}-${month}-${year}`;
                    };

                    const tuitionAmount = Number(transaction.amount) || 0;
                    const vanAmount = Number(transaction.van_fee) || 0;
                    const totalAmount = tuitionAmount + vanAmount;

                    return (
                      <tr key={transaction.id} style={{ borderBottom: '1px solid #ddd' }}>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{index + 1}</td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{formatDate(transaction.date)}</td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>₹{tuitionAmount}</td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>₹{vanAmount}</td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>₹{totalAmount}</td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{transaction.transaction_type}</td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{transaction.transaction_id}</td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                          <button
                            type="button"
                            onClick={() => {
                              printCoachingBill({
                                student: selectedCoachingStudent,
                                paymentData: {
                                  amount: tuitionAmount,
                                  van_fee_amount: vanAmount,
                                  transaction_id: transaction.transaction_id,
                                  bill_number: transaction.transaction_id,
                                  date: transaction.date
                                }
                              });
                            }}
                            style={{
                              padding: '5px 15px',
                              backgroundColor: '#007bff',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '12px'
                            }}
                          >
                            Reprint
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {selectedCoachingStudent && transactionHistory.length === 0 && (
            <div style={{ marginTop: '30px', padding: '20px', border: '1px solid #ddd', borderRadius: '8px', textAlign: 'center', color: '#666' }}>
              <p>No transaction history found for this student.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Coaching;
